module.exports = __webpack_public_path__ + "media/images/icons/icon-remote-b773cae039b96d143eaa7e811128d22b.svg";